import styled from 'styled-components';

const ErrorMessage = styled.div.attrs({
  className: 'error-message kiosko:text-kiosko-xs kiosko:bottom-[-44px]',
})`
  font-family: inherit;
  text-align: left;
  color: #f84b7a;
  white-space: nowrap;
  font-size: 11px;
  position: absolute;
  left: 0;
  bottom: -18px;
`;

export {ErrorMessage};
